<template>
  <validation-observer ref="simpleRules">
    <b-row>
      <b-col
        cols="12"
        md="8"
      >
        <b-card>
          <b-row>
            <b-col
              cols="12"
              md="8"
            >
              <b-form-group
                label="Blok Anahtarı"
                label-for="block_key"
                description="Sitenin bu bloğu bulduğu sabit anahtar (ör. home_intro, stat_1). Mevcut blokların anahtarını değiştirmeyin."
              >
                <validation-provider
                  #default="{ errors }"
                  name="Blok Anahtarı"
                  rules="required"
                >
                  <b-form-input
                    id="block_key"
                    v-model="itemData.block_key"
                    placeholder="home_intro"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                label="Sıra No"
                label-for="ordering"
              >
                <b-form-input
                  id="ordering"
                  v-model="itemData.ordering"
                  type="number"
                  placeholder="Sıra No"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Üst Başlık"
                label-for="eyebrow"
              >
                <b-form-input
                  id="eyebrow"
                  v-model="itemData.eyebrow"
                  placeholder="Küçük üst başlık (opsiyonel)"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Başlık"
                label-for="title"
              >
                <b-form-input
                  id="title"
                  v-model="itemData.title"
                  placeholder="Başlık"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Alt Başlık"
                label-for="subtitle"
              >
                <b-form-input
                  id="subtitle"
                  v-model="itemData.subtitle"
                  placeholder="Alt başlık (opsiyonel)"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Metin"
                label-for="text"
                description="İstatistik bloklarında (stat_*) başlık = rakam, metin = açıklama."
              >
                <b-form-textarea
                  id="text"
                  v-model="itemData.text"
                  rows="5"
                  placeholder="Metin"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Buton Metni"
                label-for="button"
              >
                <b-form-input
                  id="button"
                  v-model="itemData.button"
                  placeholder="Detaylı Bilgi"
                />
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                label="Buton Bağlantısı"
                label-for="link"
                description="Site sayfa anahtarı: urunlerimiz, uretim, uretim#3, page:hakkimizda, iletisim..."
              >
                <b-form-input
                  id="link"
                  v-model="itemData.link"
                  list="site-block-links"
                  placeholder="urunlerimiz"
                />
                <datalist id="site-block-links">
                  <option
                    v-for="option in linkOptions"
                    :key="option"
                    :value="option"
                  />
                </datalist>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-card title="Görsel">
          <pre-loading v-if="uploading === 'image'" />
          <template v-else>
            <b-img
              v-if="itemData.image"
              :src="mediaURL + itemData.image"
              fluid
              class="mb-1"
            />
            <b-form-file
              v-model="imageFile"
              accept="image/*"
              placeholder="Görsel seçin..."
              drop-placeholder="Dosyayı buraya bırakın..."
              browse-text="Seç"
            />
            <div class="mt-1 d-flex">
              <b-button
                variant="primary"
                size="sm"
                :disabled="!imageFile"
                @click="upload('image')"
              >
                <FeatherIcon icon="UploadIcon" />
                Yükle
              </b-button>
              <b-button
                v-if="itemData.image"
                variant="flat-danger"
                size="sm"
                class="ml-auto"
                @click="itemData.image = null"
              >
                <FeatherIcon icon="TrashIcon" />
                Kaldır
              </b-button>
            </div>
          </template>
        </b-card>
        <b-card title="Video (mp4)">
          <pre-loading v-if="uploading === 'video'" />
          <template v-else>
            <video
              v-if="itemData.video"
              :src="mediaURL + itemData.video"
              class="w-100 mb-1"
              muted
              controls
            />
            <b-form-file
              v-model="videoFile"
              accept="video/mp4,video/webm"
              placeholder="Video seçin..."
              drop-placeholder="Dosyayı buraya bırakın..."
              browse-text="Seç"
            />
            <div class="mt-1 d-flex">
              <b-button
                variant="primary"
                size="sm"
                :disabled="!videoFile"
                @click="upload('video')"
              >
                <FeatherIcon icon="UploadIcon" />
                Yükle
              </b-button>
              <b-button
                v-if="itemData.video"
                variant="flat-danger"
                size="sm"
                class="ml-auto"
                @click="itemData.video = null"
              >
                <FeatherIcon icon="TrashIcon" />
                Kaldır
              </b-button>
            </div>
          </template>
        </b-card>
        <b-alert
          show
          variant="info"
        >
          <div class="alert-body font-small-2">
            Yükleme / kaldırma işleminden sonra <b>Kaydet</b>'e basın.
            İngilizce / Almanca metinler: Dil Çeviri → İçerik Blokları.
          </div>
        </b-alert>
      </b-col>
    </b-row>
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </validation-observer>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BFormFile, BButton, BImg, BAlert,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import PreLoading from '@/layouts/components/common/PreLoading.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import siteLinks from '@/views/Admin/siteLinks'

export default {
  name: 'SiteBlocksForm',
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BButton,
    BImg,
    BAlert,
    ValidationObserver,
    ValidationProvider,
    PreLoading,
  },
  data() {
    return {
      required,
      mediaURL: `${this.$store.state.app.baseURL}/media/site_blocks/`,
      imageFile: null,
      videoFile: null,
      uploading: null,
      linkOptions: siteLinks,
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['siteBlocks/dataItem']
    },
    saveData() {
      return this.$store.getters['siteBlocks/dataSaveStatus']
    },
    isEdit() {
      return !!this.$route.params.id
    },
  },
  watch: {
    saveData(val) {
      this.itemData.submitStatus = false
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        if (this.isEdit) {
          this.getDataItem()
        } else {
          this.$router.push(`/app/site-blocks/edit/${val.id}`)
        }
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
    '$route.params.id': function reload() {
      this.init()
    },
  },
  created() {
    localize('tr')
    this.init()
  },
  methods: {
    init() {
      if (this.isEdit) {
        this.getDataItem()
      } else {
        this.$store.dispatch('siteBlocks/resetDataItem')
      }
    },
    getDataItem() {
      this.$store.dispatch('siteBlocks/getDataItem', this.$route.params.id)
    },
    upload(type) {
      this.uploading = type
      this.$store.dispatch('fileUpload/uploadFile', {
        upload_file: type === 'image' ? this.imageFile : this.videoFile,
        folder: 'site_blocks',
      })
        .then(response => {
          this.uploading = null
          if (response && response.filename) {
            this.itemData[type] = response.filename
            if (type === 'image') this.imageFile = null
            else this.videoFile = null
          } else {
            this.showToast({
              variant: 'danger', title: 'Yükleme Hatası!', icon: 'XIcon', text: 'Dosya yüklenemedi (tür veya boyut).',
            })
          }
        })
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.itemData.submitStatus = true
          this.$store.dispatch('siteBlocks/saveData', this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!', icon: 'XIcon', text: 'Lütfen zorunlu alanları doldurun.', variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: params,
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
